import { render, staticRenderFns } from "./CatNicknameDialogBase.vue?vue&type=template&id=21caa360&scoped=true"
import script from "./CatNicknameDialogBase.vue?vue&type=script&lang=ts"
export * from "./CatNicknameDialogBase.vue?vue&type=script&lang=ts"
import style0 from "./CatNicknameDialogBase.vue?vue&type=style&index=0&id=21caa360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21caa360",
  null
  
)

export default component.exports